import { useLanguage } from '../i18n/LanguageContext';
import { destinations } from '../data/destinations';
import { DestinationCard } from '../components/DestinationCard';
import { Reveal } from '../components/Reveal';

const Destinations = () => {
  const { t } = useLanguage();

  return (
    <div className="bg-ivory" data-testid="destinations-page">
      <section className="mx-auto max-w-7xl px-5 pb-24 pt-36 md:px-8 md:pt-44">
        <Reveal>
          <p className="text-[11px] font-semibold uppercase tracking-[0.35em] text-gold-dark">{t.destinationsPage.kicker}</p>
          <h1 className="mt-4 max-w-3xl font-heading text-4xl font-medium tracking-tight text-navy md:text-6xl">
            {t.destinationsPage.title}
          </h1>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-navy/60">{t.destinationsPage.sub}</p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-6 sm:grid-cols-2">
          {destinations.map((d, i) => (
            <Reveal key={d.slug} delay={Math.min(i * 0.05, 0.3)} className={i % 4 === 0 || i % 4 === 3 ? 'lg:translate-y-10' : ''}>
              <DestinationCard destination={d} className="h-[24rem] w-full md:h-[28rem]" />
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Destinations;
